import { clientDb } from '../../../shared/firebase'
import { makeAudit } from '../../../shared/helpers'
import { UserAuth } from '../../../shared/interfaces'
import { ILoanerRecord } from '../LoanerVehicles'

export const addLoaner = (user: UserAuth) => async (loaner: ILoanerRecord) => {
  try {
    await clientDb().update(
      makeAudit(user, {
        [`loaners/${loaner.id}`]: {
          ...loaner,
          createdAt: new Date().toISOString(),
        },
      })
    );
  } catch (error) {
    console.error('Error adding loaner:', error);
  }
};

export const updateLoaner =
  (user: UserAuth) => async (loanerId: string, updates: Partial<ILoanerRecord>) => {
    try {
      await clientDb().update(
        makeAudit(user, {
          [`loaners/${loanerId}`]: {
            ...updates,
            updatedAt: new Date().toISOString(),
          },
        })
      );
    } catch (error) {
      console.error('Error updating loaner:', error);
    }
  };

export const deleteLoaner = (user: UserAuth) => async (loanerId: string) => {
  try {
    await clientDb().update(
      makeAudit(user, {
        [`loaners/${loanerId}`]: null,
      })
    );
  } catch (error) {
    console.error('Error deleting loaner:', error);
  }
};

export const getLoaners = async (): Promise<Record<string, ILoanerRecord>> => {
  const snapshot = await clientDb().child('loaners').once('value')
  return snapshot.val() || {}
}
